<template>
    <section class="orderdatatable-grid">
        <acclaro-order-datatable
            ref="acclaroSearchView"
            grid-title="My Assigned Orders"
            search-route="/datatables/orders/data"
            aggregate-route="/datatables/orders/aggregates"
            filter-route="/datatables/orders/filters"
            download-route="/datatables/orders/download"
            datatable-name="orders"
            :search-param="options.searchParam"
            :tags-param="options.tagsParam"
            :filter-param="options.filtersParam"
            :filter-by-param="options.filterByParam"
            :no-results-search-links="noResultsSearchLinks(false)"
            :column-templates="templates"
            :column-structure="columns"
            :options="datatableOptions"
            :is-assigned-view="true"
        >

            <template v-slot:search="{query, placeholder, filterByKey, search, onFilter}">
                <acclaro-search-bar
                    :selected-filter-key="filterByKey"
                    :placeholder="placeholder"
                    :search-query.sync="query"
                    @filter-selected="onFilter"
                    @update:searchQuery="(searchQuery, debounceTime) => search(searchQuery, null, debounceTime)"
                    :show-dropdown="false"/>
            </template>

            <template v-slot:aggregates="props">
                <ul>
                    <li><strong>Order Words:</strong> {{ numberWithCommas(props.aggregates.total_words || 0) }}</li>
                    <li><strong>Quote Words:</strong> {{ props.aggregates.quote_words || 0 }}</li>
                    <li><strong>Quote Amount:</strong> {{ props.aggregates.quote_total }}
                    </li>
                    <li><strong>Order Amount:</strong> {{ props.aggregates.order_total }}
                    </li>
                </ul>
            </template>

        </acclaro-order-datatable>
        <div class='modal popup fade in' id='order-comment-modal' tabindex='-1' role='dialog' aria-hidden='true'>
            <div class='modal-dialog order-modal-dialog'>
                <div class='modal-content modal-order'>
                    <div class='modal-header'>
                        <div><h1><b>Comments for Orders <span class='modal-order-number'></span></b></h1></div>
                        <button type='button' class='close' data-dismiss='modal' aria-hidden='true'>&times;</button>
                    </div>
                    <div class='modal-order-body'>
                        <div id="orders-comments-container">
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import Vue from 'vue';
import './styles/order-datatable.scss';
import {
    PencilIcon,
    FileMoveIcon,
    EmailIcon
} from '../icons.js';

import AcclaroCellTags from '../Acclaro-Datatable/components/Acclaro-Cell-Tags/AcclaroCellTags';

import {
    AsLink,
    AsComments,
    AsStatus,
    AsInfo,
    AsDue,
    AsEditable,
    AsCell
} from '../Acclaro-Datatable/cells';

import statusColors from '../Acclaro-Datatable/statusColors.js';
import {noResultsSearchLinks} from './helpers';
import moment from 'moment';

export default {

    props: {

        options: {
            type: Object,
            required: true
        }
    },

    data() {
        return {
            datatableOptions: {
                orderBy: {
                    ascending: false,
                    column: 'ID'
                },
                columnsClasses: {
                    'Name': 'th-order-name',
                    'Due Date': 'th-order-due-date',
                    'Submitted': 'th-order-submitted',
                    'ID': 'th-order-order-id',
                },
            }
        }
    },

    computed: {

        columns() {
            let columns = {
                id: {displayName: 'ID'},
                comment: {displayName: 'Comments'},
                feedback_file: {displayName: 'Feedback Files'},
                tag: {displayName: 'Order Tags'},
                plunet_number: {displayName: 'Plunet'},
                account_name: {displayName: 'Account Name'},
                name: {displayName: 'Name'},
                program_name: {displayName: 'Program Name'},
                price: {displayName: 'Amount'},
                order_status: {displayName: 'Status'},
                order_type_desc: {displayName: 'Type'},
                user_name: {displayName: 'Owner'},
                supervisor_name: {displayName: 'Supervisor'},
                pm_name: {displayName: 'Project Mgr'},
                target_lang_codes: {displayName: 'Target Language(s)'},
                source_lang_codes: {displayName: 'Source Language(s)'},
                created: {displayName: 'Submitted'},
                due_at: {displayName: 'Due Date'},
                words_formatted: {displayName: 'Words'},
                po_number: {displayName: 'PO Number'},
                invoice_numbers: {displayName: 'Invoice(s)'},
                initial_delivered_at: {displayName: 'Initial Delivery Date'},
                status_in_review_at: {displayName: 'In Review Date'},
                target_file_count: {displayName: 'Completed'},
                status_completed_at: {displayName: 'Completed Date'},
            }

            // this should come from the backend
            if (!auth.account.is_programs_enabled) {
                delete columns.program_name;
            }

            // this should come from the backend
            if (auth.role == 'user' || auth.role == 'user basic' || auth.role == 'review_only' || auth.role == 'coadmin' || auth.role == 'coadminnp') {
                delete columns.plunet_number;
            }

            return columns;
        },

        templates() {

            const orderViewRoute = this.options.orderViewRoute;
            let $vm = this;

            return {
                ID: function (h, row, index) {
                    return (
                        <div>
                            <AsLink
                                link={'/orders/view/' + row.ID}
                                link-text={row.ID}
                                new-tab={false}
                            />
                        </div>
                    );
                },
                Name: function (h, row, index) {
                  return row.name;
                },
                'Program Name': function (h, row, index) {
                  return row.program_name;
                },

                Comments: function (h, row, index) {
                    const props = {
                        row,
                        column: 'Comments',
                        onClickFunction: openPopupModal,
                        showCommentsComponent: this.showCommentsComponent
                    };

                    return (
                        <AsComments props={props}/>
                    );
                },

                'Feedback Files': function (h, row, index) {
                    const props = {row, column: 'Feedback Files'};

                    let $temp = (<span>-</span>);

                    if (row['Feedback Files']) {
                        $temp = (<a
                            href={'/orders/view/' + row.ID + '?t=pickup'}
                            target="_blank">
                            <FileMoveIcon
                                title={'Feedback Files'}
                                size={17}
                                data-id={row.ID}
                                class="clickable"/>
                        </a>)
                    }

                    return ($temp);
                },

                'Order Tags': function (h, row, index) {
                    let $cellTags = (<span>-</span>);

                    const onTagClicked = (payload) => {
                        const {$event, tag} = payload;

                        function stripHtmlEntities(str) {
                            return $('<textarea />').html(str).text();
                        }

                        $vm.$refs.acclaroSearchView.updateFilters({list_title: 'tags', key: stripHtmlEntities(tag)});
                    };

                    if (row['Order Tags']) {
                        $cellTags = (
                            <AcclaroCellTags
                                onTag={onTagClicked}
                                data={row}
                            />
                        );
                    }

                    return (
                        <div class="center-cell">
                            {$cellTags}
                        </div>
                    )
                },

                'Plunet': function (h, row, index) {
                    const props = {row, column: 'Plunet'};

                    return (
                        <AsLink
                            props={props}
                            link={row.plunet_link}
                            link-text={row['Plunet']}
                        />
                    )
                },

                'Invoice(s)': function (h, row, index) {
                    let props = {row, column: 'Invoice(s)'};
                    const {invoice_numbers} = row;

                    let $cellContent = "-";
                    let emptyObj = {};

                    if (invoice_numbers) {
                        $cellContent = invoice_numbers.replaceAll('|', ' ').replace(/^,/, '').trim()
                    }

                    return (
                        <AsCell content={$cellContent} props={emptyObj}/>
                    );
                },

                Amount: function (h, row, index) {
                    let props = {row, column: 'Amount'};
                    const {Amount, price_raw, show_order_cost, ID, price} = row;

                    let $cellContent = (<span>-</span>);

                    if ((Amount || price_raw) && show_order_cost) {
                        $cellContent = (
                            <a class="clickable" onClick={() => $vm.showAmountPopup(ID)}>
                                <span>{price || $vm.strToPrice(price_raw)}</span>
                            </a>
                        );
                    }

                    return (
                        <AsCell props={props}>
                            {$cellContent}
                        </AsCell>
                    );
                },

                Status: function (h, row, index) {
                    const props = {row, column: 'Status'};
                    return (
                        <AsStatus props={props}>
                            <span class={'status-dots status-' + $vm.getStatusColor(row.Status)}></span>
                        </AsStatus>
                    );
                },

                Words: function (h, row, index) {
                    const props = {row, column: 'Words'};

                    let $content = (<span>-</span>);

                    if (row.Words && row.Words !== '0') {
                        $content = (<a class="clickable" onClick={() => $vm.showWordsPopup(row.ID)}>{row.Words}</a>);
                    }

                    return (
                        <AsCell props={props}>{$content}</AsCell>
                    );
                },

                Completed: function (h, row, index) {
                    const props = {row, column: 'Completed'};

                    let $content = (<span>-</span>);

                    if (row.Completed) {
                        $content = (
                            <a
                                target="_blank"
                                href={'/download?ft=' + props.row.ID + '&t=target'}
                                class="clickable">{row.Completed}</a>
                        )
                    }

                    return (
                        <AsCell props={props}>
              <span>
                {$content}
              </span>
                        </AsCell>
                    );
                },

                'Due Date': function (h, row, index) {
                    return (
                        <div>
              <span style={row.is_overdue === true ? 'color:#CC0000' : ''}>
                {$vm.formatDate(row['Due Date'])}
              </span>
                        </div>
                    );
                },
            }
        }
    },

    methods: {

        noResultsSearchLinks,

        strToPrice(amount) {
            let amountFloat = parseFloat(amount);

            if (isNaN(amountFloat) || amountFloat == 0) {
                return '-';
            }

            return '$' + (this.numberWithCommas(amountFloat.toFixed(2)));
        },

        numberWithCommas(x) {
            return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        },

        //legacy code for amount popup
        showAmountPopup(orderid) {
            popupPage(
                '/ajax/reports?report=price&oid=' + orderid,
                'Order ' + orderid + ': Costs',
                false,
                true
            );
        },

        getStatusColor(status) {
            return statusColors[status.toLowerCase()];
        },

        //legacy code for words popup
        showWordsPopup(orderid) {
            popupPage(
                '/ajax/reports?report=words&oid=' + orderid,
                'Order ' + orderid + ': Word Statistics',
                false
            );
        },

        formatDate(date) {
            if (!moment(date).isValid()) return '-';

            return moment(date).format('DD-MMM-YYYY')
        },

        pastDue(date) {
            if (!moment(date).isValid()) return false;

            return moment(date).isBefore(moment(), 'day');
        },
    }
}
</script>
